"use client";
import {
  asMenuItem,
  findOwnerMenuItem,
  getNestedMenu,
  useMenu,
} from "@/context/menu-context";
import { useUnit } from "@/context/unit-context";
import { Content } from "@/services/content/types";
import { usePathname } from "next/navigation";
import ActiveLink from "./active-link";

type SubNavigationProps = {
  menu?: Content.Menu;
};

const SubNavigation = ({ menu }: SubNavigationProps) => {
  const headerMenu = useMenu("menu-header");
  const pathname = usePathname();
  const { currentUnit } = useUnit();

  let resolved: Content.Menu | undefined = menu;
  if (!resolved) {
    resolved = getNestedMenu(findOwnerMenuItem(headerMenu, pathname));
  }
  if (!resolved && currentUnit) {
    const unitSlug = currentUnit.replace(/^unit-/, "");
    const top = headerMenu?.fields?.menuItems ?? [];
    const match = top
      .map(asMenuItem)
      .find((mi) => mi?.fields?.item?.fields?.slug === unitSlug);
    resolved = getNestedMenu(match);
  }

  const items = resolved?.fields?.menuItems
    ?.map(asMenuItem)
    .filter((x): x is Content.MenuItem => Boolean(x));

  if (!items || items.length === 0) return null;

  return (
    <nav className="bg-sand-500 relative">
      <div className="container relative overflow-x-auto scrollbar-none px-0 after:pointer-events-none after:absolute after:right-0 after:top-0 after:h-full after:w-8 after:bg-gradient-to-r after:from-transparent after:to-sand-500">
        <ul className="flex whitespace-nowrap p-0">
          {items.map((menuItem) => {
            const rawHref =
              menuItem.fields.item?.fields?.slug ?? menuItem.fields.url ?? "#";
            const normalized =
              rawHref === "#" || rawHref.startsWith("/")
                ? rawHref
                : `/${rawHref}`;
            const href = normalized === "/index" ? "/" : normalized;
            return (
              <li key={menuItem.sys.id} className="shrink-0">
                <ActiveLink
                  className="inline-block text-gray-500 hover:underline font-normal text-sm md:text-base px-3 py-4 text-center"
                  activeClassName="!font-bold"
                  href={href}
                >
                  {menuItem.fields.label}
                </ActiveLink>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default SubNavigation;
